export default __webpack_public_path__ + "static/media/충남.4a1050b2.png";